import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration from config file

/**
 * Class representing the view for partner products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: 'dbllist', // Double list view for Franchises
            id: 'dbllist', // ID for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Franquicias no agregadas'), // Left label for unadded Franchises
            labelRight: _('Franquicias Agregadas'), // Right label for added Franchises
            data: [], // Initial data for the list
        };
        return {
            view: 'form', // Form view
            id: 'f1', // Form ID
            rows: [
                {
                    view: 'forminput', // Input field for form
                    name: 'access', // Name of the input field
                    body: list1, // Body of the input field
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Label alignment
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Variable to hold values of included Franchises
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var string1 = ''; // String to hold query parameters

        // Event listener for partner franchise filtering
        this.on(this.app, 'partnerFranchise:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ''; // Reset query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other parameters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dbllist').$$('left').clearAll(); // Clear left list
            $$('dbllist').setValue([]); // Reset selected values
            webix
                .ajax() // AJAX request to fetch partner franchises
                .get(devConfig.geturlApi() + 'PartnersFranchises/GetGroupPartnersFranchises', string1, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Show error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text); // Parse response data
                        if (!data.HasError) {
                            $$('dbllist').$$('left').clearAll(); // Clear left list
                            $$('dbllist').setValue([]); // Reset selected values
                            $$('dbllist').parse(
                                data.Data.ExcludedFranchisesList, // Parse excluded franchises into the list
                            );
                            $$('dbllist').setValue(
                                data.Data.IncludedFranchisesList, // Set included franchises as selected
                            );
                            values = data.Data.IncludedFranchisesList; // Store included franchises
                        } else {
                            webix.message('Error! '); // Show error message if there's an error
                        }
                    },
                });
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            var array1 = values.split(','); // Split included franchises into an array
            var array2 = $$('dbllist').getValue().split(','); // Split currently selected franchises into an array
            var arrayAgregados = []; // Array to hold added franchises
            var arrayEliminados = []; // Array to hold removed franchises
            array2.forEach(function (obj) {
                var found = array1.find(function (element) {
                    return element == obj; // Check if the franchise is already included
                });
                if (found != undefined) {
                    // If found, do nothing
                } else {
                    arrayAgregados.push(obj); // If not found, add to added franchises
                }
            });
            array1.forEach(function (obj) {
                var found = array2.find(function (element) {
                    return element == obj; // Check if the franchise is still selected
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // If not found, add to removed franchises
                } else {
                    // If found, do nothing
                }
            });
            values = $$('dbllist').getValue(); // Update values with currently selected franchises
            webix
                .ui({
                    view: 'window', // Create a confirmation window
                    head: {
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        view: 'form', // Form inside the window
                        id: 'form', // Form ID
                        elements: [
                            {
                                view: 'text', // Text input for observation
                                label: _('Observación'), // Label for the input
                                name: 'Note', // Name of the input
                                required: false, // Not required
                                labelWidth: 100, // Width of the label
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Button label
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('form').setValues(
                                                $$('form').getCleanValues(), // Reset form values
                                            );
                                            webix
                                                .ajax() // AJAX request to refresh the franchise list
                                                .get(
                                                    devConfig.geturlApi() + 'PartnersFranchises/GetGroupPartnersFranchises',
                                                    string1,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Show error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var data = JSON.parse(
                                                                text, // Parse response data
                                                            );
                                                            if (!data.HasError) {
                                                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                                                $$('dbllist').setValue([]); // Reset selected values
                                                                $$('dbllist').parse(
                                                                    data.Data.ExcludedProductsList, // Parse excluded products into the list
                                                                );
                                                                $$('dbllist').setValue(
                                                                    data.Data.IncludedProductsList, // Set included products as selected
                                                                );
                                                                values = data.Data.IncludedProductsList; // Store included products
                                                            } else {
                                                                webix.message(
                                                                    'Error! ', // Show error message if there's an error
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form', // Button type
                                        value: _('Guardar'), // Button label
                                        click: function ($e) {
                                            this.getTopParentView().hide(); // Hide the window
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                // Validate form
                                                var vthis = this; // Reference to the current button
                                                webix
                                                    .ajax() // AJAX request to save changes
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'PartnersFranchises/SaveGroupPartnersFranchises',
                                                        '{"Partner":"' +
                                                            id_partner +
                                                            '","IncludedFranchisesList":"' +
                                                            arrayAgregados +
                                                            '","ExcludedFranchisesList":"' +
                                                            arrayEliminados +
                                                            '","Note":"' +
                                                            valuesForm.Note +
                                                            '","CountrySelect":"' +
                                                            $$('CountrySelect').getValue() +
                                                            '"}', // Send data as JSON
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Show error message on failure
                                                                );
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(
                                                                    text, // Parse response data
                                                                );
                                                                if (!data.HasError) {
                                                                    webix.message(
                                                                        _(
                                                                            'Franquicia Partner Editado', // Show success message
                                                                        ),
                                                                    );
                                                                } else {
                                                                    webix.message(
                                                                        _('Error! '), // Show error message if there's an error
                                                                    );
                                                                }
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error message title
                                                    type: 'alert-error', // Error message type
                                                    text: _(
                                                        'Completa los campos...', // Error message text
                                                    ),
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
